import { Text } from "react-native-paper";
import { useAppTheme } from "../../../useAppTheme";
import Box from "../../Box";

const StudySessionAppBarLeft = ({
	title,
	userName,
	numericId,
}: {
	title: string;
	userName: string;
	numericId: number;
}) => {
	const theme = useAppTheme();
	return (
		<Box flexDirection="column" gap={2}>
			<Text
				variant="titleLarge"
				numberOfLines={2}
				style={{
					color: theme.colors.white,
				}}
			>
				{title}
			</Text>
			<Text
				variant="bodyLarge"
				style={{ textTransform: "capitalize", color: theme.colors.white }}
			>
				{`${userName || ""} • Test #${numericId}`}
			</Text>
		</Box>
	);
};

export default StudySessionAppBarLeft;
